import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ABSENCE_TYPES, ABSENCE_STATUS } from "@/lib/format";
import { DatePicker } from "@/components/DatePicker";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AbsenceStatus = ({ status, testId }) => {
  const [label, cls] = ABSENCE_STATUS[status];
  return <span className={`px-1.5 py-0.5 text-[11px] font-semibold uppercase ${cls}`} data-testid={testId}>{label}</span>;
};

export const AbsenceForm = ({ employees, onSaved, testPrefix = "absence", submitLabel = "Salva" }) => {
  const [form, setForm] = useState({ employee_id: "", type: "FERIE", date_from: "", date_to: "", notes: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v, ...(k === "date_from" && (!f.date_to || f.date_to < v) ? { date_to: v } : {}) }));
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/hr/absences", { ...form, employee_id: form.employee_id || null });
      toast.success(employees ? "Assenza registrata" : "Richiesta inviata al responsabile");
      setForm({ employee_id: "", type: "FERIE", date_from: "", date_to: "", notes: "" });
      onSaved?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid gap-3" data-testid={`${testPrefix}-form`}>
      {employees && (
        <div>
          <Label className="micro-label">Dipendente</Label>
          <Select value={form.employee_id || undefined} onValueChange={set("employee_id")}>
            <SelectTrigger className="mt-1.5" data-testid={`${testPrefix}-employee-select`}><SelectValue placeholder="Seleziona dipendente" /></SelectTrigger>
            <SelectContent>{employees.map((e) => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
      <div>
        <Label className="micro-label">Tipo</Label>
        <Select value={form.type} onValueChange={set("type")}>
          <SelectTrigger className="mt-1.5" data-testid={`${testPrefix}-type-select`}><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(ABSENCE_TYPES).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div><Label className="micro-label">Dal</Label><div className="mt-1.5"><DatePicker value={form.date_from} onChange={set("date_from")} testId={`${testPrefix}-date-from`} /></div></div>
        <div><Label className="micro-label">Al</Label><div className="mt-1.5"><DatePicker value={form.date_to} onChange={set("date_to")} testId={`${testPrefix}-date-to`} /></div></div>
      </div>
      <div>
        <Label className="micro-label">Note</Label>
        <Textarea className="mt-1.5" value={form.notes} onChange={(e) => set("notes")(e.target.value)} data-testid={`${testPrefix}-notes`} />
      </div>
      <Button onClick={save} disabled={busy || !form.date_from || !form.date_to || (employees && !form.employee_id)} data-testid={`${testPrefix}-submit`}>{busy ? "Salvataggio…" : submitLabel}</Button>
    </div>
  );
};
